import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mobile-minicart" }
const _hoisted_2 = {
  border: "0",
  cellspacing: "0",
  cellpadding: "0",
  class: "mobile-minicart-toggle"
}
const _hoisted_3 = { width: "50%" }
const _hoisted_4 = {
  width: "50%",
  align: "right"
}

import { calculateQuoteTotal, formatAmount } from "@/utils/Utils";
import { defineComponent, inject, computed, ComputedRef } from "vue";
import { useQuoteStore } from "@/stores/root/quote";


export default /*@__PURE__*/_defineComponent({
  __name: 'QuoteCartMobile',
  setup(__props) {

const inj = inject("$emitter");
const quote = useQuoteStore();

function showMobileCart() {
  (inj as any).emit("show-mobile-cart");
}

const quoteTotal: ComputedRef<number> = computed(() => {
  return calculateQuoteTotal(quote);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("td", _hoisted_3, [
            _cache[1] || (_cache[1] = _createElementVNode("b", null, "Due Today: ", -1)),
            _createTextVNode(_toDisplayString(_unref(formatAmount)(quoteTotal.value)), 1)
          ]),
          _createElementVNode("td", _hoisted_4, [
            _createElementVNode("span", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showMobileCart()))
            }, "Your Quote")
          ])
        ])
      ])
    ])
  ]))
}
}

})